export var REACTION_KEY;
(function(REACTION_KEY2) {
  REACTION_KEY2["reactor"] = "reactor";
})(REACTION_KEY || (REACTION_KEY = {}));
